var map = {
	"./dice-1.png": 9887,
	"./dice-2.png": 7428,
	"./dice-3.png": 8557,
	"./dice-4.png": 5762,
	"./dice-5.png": 9419,
	"./dice-6.png": 4016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9539;